import { useState, useEffect } from "react";

export default function EditBannerModal({ isOpen, banner, onClose, onSave }) {
  const [title, setTitle] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [imageFile, setImageFile] = useState(null);
  const [preview, setPreview] = useState("");

  useEffect(() => {
    if (!banner) return;

    setTitle(banner.title || "");
    setIsActive(banner.isActive ?? true);
    setPreview(banner.image || "");
    setImageFile(null);
  }, [banner]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setImageFile(file);
    setPreview(URL.createObjectURL(file));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", title);
    formData.append("isActive", isActive);

    // only send new file if replaced
    if (imageFile) formData.append("image", imageFile);

    onSave({
      id: banner._id,
      formData,
    });
  };

  if (!isOpen || !banner) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full">
        <div className="border-b px-6 py-4 flex justify-between items-center">
          <h2 className="text-xl font-bold">Edit Banner</h2>
          <button onClick={onClose}>
            <i className="ri-close-line text-2xl"></i>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-6">

          {/* TITLE */}
          <div>
            <label className="block text-sm font-medium mb-2">Title</label>
            <input
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="w-full border rounded-lg px-4 py-2.5"
              required
            />
          </div>

          {/* IMAGE */}
          <div>
            <label className="block text-sm font-medium mb-2">
              Replace Image (optional)
            </label>

            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              className="w-full"
            />

            {preview && (
              <div className="mt-3 h-48 rounded-lg overflow-hidden border">
                <img
                  src={preview}
                  alt="preview"
                  className="w-full h-full object-cover"
                />
              </div>
            )}
          </div>

          {/* ACTIVE */}
          <div className="flex items-center justify-between">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Show Banner
                </label>
                <p className="text-xs text-gray-500 mt-1">Show this banner on the website</p>
              </div>
              <button
                type="button"
                onClick={() => setIsActive(!isActive)}
                className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors cursor-pointer ${
                  isActive ? 'bg-pink-500' : 'bg-gray-300'
                }`}
              >
                <span
                  className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                    isActive ? 'translate-x-6' : 'translate-x-1'
                  }`}
                />
              </button>
            </div>

          {/* ACTIONS */}
          <div className="flex gap-3 pt-4 border-t">
            <button type="button" onClick={onClose} className="flex-1 border py-2.5 rounded-lg">
              Cancel
            </button>
            <button type="submit" className="flex-1 bg-pink-500 text-white py-2.5 rounded-lg">
              Update Banner
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
